import React from "react";

const GMSBorderlessButton = ({
  name = "",
  type = "button",
  onClick,
  id = "",
  color = "#091caa",
  disabled = false,
  fontSize = "13px",
  className = "",
  "data-testid": dataTestId = undefined,
  ...props
}) => {
  return (
    <div>
      <button
        type={type}
        className={`bg-transparent border-0 ${className}`}
        style={{
          color: disabled ? "#BAC0CA" : color,
          fontSize: fontSize,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        id={id}
        data-testid={dataTestId}
        onClick={onClick}
        // `disabled` was commented out here, so every caller that passed it got the greyed-out
        // COLOUR without the button actually becoming inert -- it looked unavailable and still
        // fired. Reinstated 2026-08-03. Blast radius was checked across all 7 callers that pass it:
        //   - HourRepeatSchedule / DayRepeatSchedule / WeekRepeatSchdule: no-op. The button only
        //     renders while `scheduleInfo.endDate === ""`, so the flag is always false there.
        //   - PromotionView: now genuinely blocks a second click while a publish/rollback request
        //     is in flight, which is what it was always for.
        //   - RelevantCategories / PdwAttributeOrder / CreateEditProduct Reset: correctly inert
        //     while there is nothing to reset.
        disabled={disabled}
      >
        {name}
      </button>
    </div>
  );
};

export default GMSBorderlessButton;
